import { PageHeader } from "@/components/site/PageHeader";
import { Owner } from "@/components/site/Owner";
import { Reveal } from "@/components/site/Reveal";
import { HFPA_VALUES, OWNER_STORY, OWNER_MISSION, OWNER_STORY_CLOSE } from "@/data";

export default function MeetOwnerPage() {
  return (
    <>
      <PageHeader
        overline="Leadership"
        title="Meet the"
        accent="owner."
        subtitle="The vision, standards, and heart behind Heritage Family Protection Agency."
      />

      <Owner />

      <section className="relative py-20 md:py-28" data-testid="owner-story-section">
        <div className="max-w-3xl mx-auto px-6 md:px-12">
          <Reveal>
            <p className="font-body text-xs md:text-sm tracking-[0.3em] uppercase text-[#d4af37]">His Story</p>
            <h2 className="mt-4 font-serif-display text-4xl sm:text-5xl font-medium tracking-tight text-white">
              From Louisville to <span className="text-gold-gradient italic">legacy.</span>
            </h2>
          </Reveal>
          <div className="mt-10 space-y-6">
            {OWNER_STORY.map((p, i) => (
              <Reveal key={i} delay={Math.min(i, 4) * 0.03}>
                <p className="font-body font-light text-base md:text-lg leading-relaxed text-white/65">{p}</p>
              </Reveal>
            ))}
          </div>
          <Reveal>
            <blockquote className="my-12 border-l-2 border-[#d4af37] pl-6 md:pl-8 font-serif-display text-2xl md:text-3xl italic leading-relaxed text-gold-gradient" data-testid="owner-mission-quote">
              {OWNER_MISSION}
            </blockquote>
          </Reveal>
          <div className="space-y-6">
            {OWNER_STORY_CLOSE.map((p, i) => (
              <Reveal key={i} delay={i * 0.05}>
                <p className={`font-body font-light leading-relaxed ${i === OWNER_STORY_CLOSE.length - 1 ? "text-lg md:text-xl text-white/80 italic" : "text-base md:text-lg text-white/65"}`}>
                  {p}
                </p>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="relative py-20 md:py-28 bg-[#0a192f] border-t border-[#bf953f]/10">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <Reveal>
            <p className="font-body text-xs md:text-sm tracking-[0.3em] uppercase text-[#d4af37]" data-testid="hfpa-values-overline">What H.F.P.A Stands For</p>
          </Reveal>
          <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-testid="hfpa-values-grid">
            {HFPA_VALUES.map((m, i) => (
              <Reveal key={m.letter} delay={i * 0.08}>
                <div className="border-t border-[#bf953f]/25 pt-6 h-full">
                  <span className="font-serif-display text-5xl text-gold-gradient">{m.letter}</span>
                  <h3 className="mt-3 font-serif-display text-2xl text-white">{m.word}</h3>
                  <p className="mt-3 font-body font-light text-sm md:text-base leading-relaxed text-white/60">{m.body}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
